import script from "./Manage_platformEN.vue?vue&type=script&setup=true&name=Mannage_platform&lang=js"
export * from "./Manage_platformEN.vue?vue&type=script&setup=true&name=Mannage_platform&lang=js"

import "./Manage_platformEN.vue?vue&type=style&index=0&id=8520960a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8520960a"]])

export default __exports__